import React from 'react';
import classNames from 'classnames';

const RightsTableData = ({ children, lockingId, roleId, onClick }) => {
	const classes = classNames({
		'c-rights-table-cell': true,
		['js-locking-' + lockingId]: lockingId,
		['js-role-' + roleId]: roleId,
		'is-clickable': onClick ? true : false
	});
	return (
		<div className={classes} onClick={onClick}>
			{children}
		</div>
	);
};

export default RightsTableData;



// WEBPACK FOOTER //
// ./src/js/plan/rights/RightsTableData.js